import { DatePicker } from 'rsuite';

const DateBox = ({
  label,
  name,
  isRequired,
  placeholder,
  value,
  defaultValue,
  handleChange,
  maxDate,
  minDate,
  errormsg,
  fieldFlag,
  disabled,
  position,
}) => {
  // const handleRsuiteChange = (val) => {
  //   if (val) {
  //     // Format the date to 'YYYY-MM-DD' in local time zone
  //     const formattedDate = `${val.getFullYear()}-${(val.getMonth() + 1).toString().padStart(2, '0')}-${val.getDate().toString().padStart(2, '0')}`;
  //     handleChange({ target: { name, value: formattedDate } }, fieldFlag);
  //   }
  // };

const handleRsuiteChange = (val) => {
  if (val) {
    // Format the date to 'YYYY-MM-DD' in local time zone
    const formattedDate = `${val.getFullYear()}-${(val.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${val.getDate().toString().padStart(2, '0')}`;
    handleChange({ target: { name, value: formattedDate } }, fieldFlag);
  } else {
    // ✅ Handle clear button (cross icon)
    handleChange({ target: { name, value: null } }, fieldFlag);
  }
};

  const getDisabledDateFn = () => {
    return (date) => {
      if (minDate) {
        const min = new Date(minDate);
        min.setHours(0, 0, 0, 0);
        if (date < min) return true;
      }
      if (maxDate) {
        const max = new Date(maxDate);
        max.setHours(23, 59, 59, 999);
        if (date > max) return true;
      }
      return false;
    };
  };

  // Parse the value or defaultValue into a Date object
  const parsedValue = value
    ? new Date(value) // When value is a valid string, convert to Date
    : defaultValue
      ? new Date(defaultValue)
      : null;

  return (
    <>
      <label htmlFor={name}>
        {label}
        {isRequired && <span className="required-star">*</span>}
      </label>
      <DatePicker
        id={`textarea-${name}`}
        name={name}
        format="MM/dd/yyyy" // Display format for the user
        value={parsedValue} // Use Date object for value
        onChange={handleRsuiteChange} // Handle date change
        placeholder={placeholder}
        disabled={disabled}
        oneTap
        placement={position}
        block
        shouldDisableDate={getDisabledDateFn()} // Disable dates based on min and max
        editable={false}
      />
      {errormsg && <div className="error-message">{errormsg}</div>}
    </>
  );
};

export default DateBox;
